import StickerPicker from "./sticker";
import EmojiPicker from "./emoji";
const MessagePicker = ({ onSelectEmoji, onSelectGif, isEmoji, isGif,disabled }) => {
  return (
    <div className="input_picker_buttons">
      {isEmoji && <EmojiPicker onSelectEmoji={onSelectEmoji} disabled={disabled} />}
      {isGif && <StickerPicker onSelectGif={onSelectGif} disabled={disabled}/>}
    </div>
  );
};

export default MessagePicker;
